// extracted by mini-css-extract-plugin
export default {"container":"InvitesTable_container__AZuXP","table":"InvitesTable_table__5lWZ2","tableItem__options":"InvitesTable_tableItem__options__C1AFk","loader":"InvitesTable_loader__qXiXS"};